import CommonLayout from "containers/Client/AccountPage/CommonLayout";
import { AuthContext } from "context/appContext";
import { ProfilClient } from "data/types";
import { useAppDispatch, useAppSelector } from "hooks/hooks";
import { FC, Fragment, useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  getLocationById,
  getLocationByUserId,
  previousValidationStep,
  resetValues,
  setLocationData,
  updateLocationJustification,
  validationNextStep,
} from "redux/features/location/locationSlice";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import LocationCompanyImagesDataModern from "./components/LocationCompanyImagesDataModern";
import LocationCompanyPersonalDataModern from "./components/LocationCompanyPersonalDataModern";
import LocationConfirmationModern from "./components/LocationConfirmationModern";
import LocationParticularDetailedData from "./components/LocationParticularDetailedData";
import LocationParticularImagesData from "./components/LocationParticularImagesData";
import LocationUserType from "./components/LocationUserType";
import ValidationProgressIndicator from "./components/ValidationProgressIndicator";
import { socket } from "utils/socket";

export interface PageAddListing10Props {}
const Congrats: FC<PageAddListing10Props> = () => {
  const authContext = useContext(AuthContext);
  let userId: number | undefined;
  let role = "";

  userId = authContext.user?.id;
  role = authContext.user?.role ?? "";

  let profile = authContext.user?.profil as ProfilClient;
  const user_validation = profile?.validation;

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const locationState = useAppSelector((state) => state.location);
  const progress = (locationState.validationStep / locationState.validationTotalSteps) * 100;

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [event, setEvent] = useState<Event>(new Event(""));

  useEffect(() => {
    dispatch(resetValues());
  }, []);

  // Debug pour voir la valeur de validationStep
  useEffect(() => {
    // Debug info removed
  }, [locationState.validationStep, locationState.locationData]);

  const handleNextClick = () => {
    const currentStep = locationState.validationStep;
    switch (currentStep) {
      case 1: {
        setEvent(new Event("chekLocationFormThirteenOwner"));
        break;
      }
      case 2: {
        if (locationState?.locationData?.category === "company") {
          setEvent(new Event("chekLocationFormFourteenCompany"));
        }
        if (locationState?.locationData?.category === "particular") {
          setEvent(new Event("chekLocationFormFourteenParticular"));
        }
        break;
      }
      case 3: {
        if (locationState?.locationData?.category === "company") {
          setEvent(new Event("chekLocationFormFifteenCompany"));
        }
        if (locationState?.locationData?.category === "particular") {
          setEvent(new Event("chekLocationFormFifteenParticular"));
        }
        break;
      }
      case 4: {
        setEvent(new Event("confirmLocation"));
        break;
      }
      default: {
        setEvent(new Event(""));
        break;
      }
    }
  };

  // Fonction pour revenir à l'étape précédente
  // const handlePreviousClick = () => {
  //   dispatch(previousValidationStep());
  // };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [locationState.validationStep]);

  useEffect(() => {
    switch (locationState.validationLoading) {
      case "pending": {
        setIsLoading(true);
        break;
      }
      case "succeeded": {
        setIsLoading(false);
        if (locationState.locationData && locationState.validationStep === 4) {
          dispatch(updateLocationJustification({ data: locationState.locationData, id: id }));
        } else {
          dispatch(validationNextStep());
        }
        break;
      }
      case "failed": {
        setIsLoading(false);
        break;
      }
    }
  }, [locationState.validationLoading]);

  const { id } = useParams();
  const initialRender = useRef(true);

  useEffect(() => {
    const fetchData = async () => {
      if (locationState.locationData && locationState.validationStep === 4) {
        const res = await dispatch(updateLocationJustification({ data: locationState.locationData, id: id }));

        if (res) {
          socket.emit("send-notification", {
            action: "create_espace",
            senderId: locationState.locationData?.userId,
            location: locationState?.locationData,
            locationId: locationState?.locationData?.id,
          });
        }

        dispatch(getLocationByUserId(String(userId)));

        // Réinitialiser les états pour afficher le message de succès
        setIsCompleterClicked(false);
        setIsSubmissionCompleted(true);
        dispatch(resetValues());
      }
    };

    fetchData();
  }, [locationState.locationData]);

  useEffect(() => {
    if (!initialRender.current && locationState.locationData && locationState.validationStep !== 4) {
      dispatch(validationNextStep());
      setIsLoading(false);
    }

    initialRender.current = false;
  }, [locationState.locationData]);

  useEffect(() => {
    if (id) {
      dispatch(getLocationById(id));
    }
  }, [id]);

  const [isCompleterClicked, setIsCompleterClicked] = useState<boolean>(false);
  const [isSubmissionCompleted, setIsSubmissionCompleted] = useState<boolean>(false);

  const handleShowForm = () => {
    setIsCompleterClicked(true);
    // Initialiser à l'étape 1 si on est encore à l'étape 0
    if (locationState.validationStep === 0) {
      dispatch(validationNextStep());
    }
  };

  const handleNavigate = () => {
    navigate("/client/locations");
  };
  const handleNavigate2 = () => {
    navigate("/client/demande");
  };

  return (
    <Fragment>
      <CommonLayout>
        <div className="relative overflow-hidden bg-gradient-to-br from-green-50 via-blue-50 to-purple-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 min-h-screen p-6">
          <div className="max-w-2xl mx-auto pt-8">
            {/* Icône de succès animée - uniquement si pas en mode completion */}
            {!isCompleterClicked && (
              <div className="text-center mb-8">
                <div className="inline-flex items-center justify-center w-24 h-24 bg-gradient-to-r from-green-400 to-green-600 rounded-full mb-6 animate-bounce">
                  <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
              </div>
            )}

            {/* Contenu principal - uniquement si pas en mode completion */}
            {!isCompleterClicked && (
              <div className="bg-white dark:bg-gray-800 rounded-3xl shadow-2xl p-8 text-center border border-gray-100 dark:border-gray-700">
                {user_validation === "approuvé" || isSubmissionCompleted ? (
                  <>
                    <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">Félicitations !</h1>
                    <h2 className="text-xl font-semibold text-green-600 dark:text-green-400 mb-6">
                      Demande soumise avec succès
                    </h2>
                    <p className="text-lg text-gray-600 dark:text-gray-300 mb-8 leading-relaxed">
                      Votre demande a bien été enregistrée et est actuellement en cours de traitement par notre
                      équipe. Vous recevrez une notification dès qu'elle sera validée.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                      <ButtonPrimary
                        className="bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 px-8 py-4 text-lg font-semibold rounded-full transform hover:scale-105 transition-all duration-200"
                        onClick={isSubmissionCompleted ? handleNavigate2 : handleNavigate}
                      >
                        Voir mes espaces
                      </ButtonPrimary>
                    </div>
                  </>
                ) : authContext?.user?.isCustomer ? (
                  <>
                    <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">✨ Presque terminé !</h1>
                    <h2 className="text-xl font-semibold text-blue-600 dark:text-blue-400 mb-6">
                      Votre espace est en cours de traitement
                    </h2>
                    <p className="text-lg text-gray-600 dark:text-gray-300 mb-8 leading-relaxed">
                      Super ! Votre demande a bien été enregistrée et est en cours de traitement par notre équipe.
                      Nous vous tiendrons informé de l'avancement.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                      <ButtonPrimary
                        className="bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 px-8 py-4 text-lg font-semibold rounded-full transform hover:scale-105 transition-all duration-200"
                        onClick={handleNavigate2}
                      >
                        📋 Voir mes espaces
                      </ButtonPrimary>
                    </div>
                  </>
                ) : (
                  <>
                    {user_validation !== "approuvé" && !isCompleterClicked && (
                      <>
                        <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
                          Une dernière étape
                        </h1>
                        <h2 className="text-xl font-semibold text-orange-600 dark:text-orange-400 mb-6">
                          Documents requis pour finaliser
                        </h2>
                        <p className="text-lg text-gray-600 dark:text-gray-300 mb-8 leading-relaxed">
                          Parfait ! Votre demande a bien été enregistrée. Pour finaliser la validation de votre
                          espace, veuillez fournir les documents nécessaires.
                        </p>
                        <div className="bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 rounded-2xl p-6 mb-8">
                          <div className="flex items-center justify-center mb-4">
                            <div className="w-12 h-12 bg-orange-100 dark:bg-orange-800 rounded-full flex items-center justify-center">
                              <svg
                                className="w-6 h-6 text-orange-600 dark:text-orange-400"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                                />
                              </svg>
                            </div>
                          </div>
                          <p className="text-orange-800 dark:text-orange-300 font-medium">
                            Documents requis : Pièce d'identité, justificatif de propriété, assurance
                          </p>
                        </div>
                        <div className="flex flex-col sm:flex-row gap-4 justify-center">
                          <ButtonPrimary
                            className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 px-8 py-4 text-lg font-semibold rounded-full transform hover:scale-105 transition-all duration-200"
                            onClick={handleShowForm}
                          >
                            Compléter mes documents
                          </ButtonPrimary>
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>
            )}

            {/* Message d'encouragement - uniquement si pas en mode completion */}
            {!isCompleterClicked && (
              <div className="text-center mt-8">
                <p className="text-gray-500 dark:text-gray-400 text-sm">
                  💡 Une question ? Contactez notre support à{" "}
                  <a href="mailto:support@eventtobee.com" className="text-blue-600 hover:underline">
                    support@eventtobee.com
                  </a>
                </p>
              </div>
            )}

            {/* Formulaires de validation - dans le conteneur centré */}
            {isCompleterClicked && (
              <div className="mt-6 space-y-8">
                {/* Header avec salutation */}
                <div className="text-center">
                  <p className="text-lg text-gray-700 dark:text-gray-300">
                    Bonjour
                    <span className="ml-2 font-bold text-gray-900 dark:text-white">
                      {profile?.name} {profile?.lastName}
                    </span>
                    👋
                  </p>
                  <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                    Finalisons ensemble la validation de votre espace
                  </p>
                </div>

                {/* Indicateur de progression modernisé */}
                <ValidationProgressIndicator
                  currentStep={locationState.validationStep}
                  totalSteps={locationState.validationTotalSteps}
                  className="mb-8"
                />

                {/* Contenu des étapes dans un conteneur moderne */}
                <div className="min-h-[600px] bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-8">
                  {locationState.validationStep === 1 && (
                    <LocationUserType
                      isLoading={isLoading}
                      role={role ?? ""}
                      handleForm={event}
                      FormData={(data: any) =>
                        dispatch(setLocationData({ ...locationState.locationData, ...data }))
                      }
                      errorLocationForm={locationState.locationError}
                    />
                  )}

                  {/* Company profil */}
                  {locationState.validationStep === 2 && locationState.locationData?.category === "company" && (
                    <LocationCompanyPersonalDataModern
                      isLoading={isLoading}
                      role={role ?? ""}
                      handleForm={event}
                      FormData={(data: any) =>
                        dispatch(setLocationData({ ...locationState.locationData, ...data }))
                      }
                      errorLocationForm={locationState.locationError}
                    />
                  )}

                  {locationState.validationStep === 3 && locationState.locationData?.category === "company" && (
                    <LocationCompanyImagesDataModern
                      isLoading={isLoading}
                      role={role ?? ""}
                      handleForm={event}
                      FormData={(data: any) =>
                        dispatch(setLocationData({ ...locationState.locationData, ...data }))
                      }
                      errorLocationForm={locationState.locationError}
                    />
                  )}

                  {/* Particular profil */}
                  {locationState.validationStep === 2 && locationState.locationData?.category === "particular" && (
                    <LocationParticularDetailedData
                      isLoading={isLoading}
                      role={role ?? ""}
                      handleForm={event}
                      FormData={(data: any) =>
                        dispatch(setLocationData({ ...locationState.locationData, ...data }))
                      }
                      errorLocationForm={locationState.locationError}
                    />
                  )}

                  {locationState.validationStep === 3 && locationState.locationData?.category === "particular" && (
                    <LocationParticularImagesData
                      isLoading={isLoading}
                      role={role ?? ""}
                      handleForm={event}
                      FormData={(data: any) =>
                        dispatch(setLocationData({ ...locationState.locationData, ...data }))
                      }
                      errorLocationForm={locationState.locationError}
                    />
                  )}

                  {locationState.validationStep === 4 && (
                    <LocationConfirmationModern
                      isLoading={isLoading}
                      role={role ?? ""}
                      handleForm={event}
                      FormData={(data: any) =>
                        dispatch(setLocationData({ ...locationState.locationData, ...data }))
                      }
                      errorLocationForm={locationState.locationError}
                    />
                  )}
                </div>

                {/* Navigation modernisée */}
                <div className="flex items-center justify-between w-full mt-12 pt-8 border-t border-gray-200 dark:border-gray-700">
                  <ButtonSecondary
                    onClick={() => dispatch(previousValidationStep())}
                    disabled={locationState.validationStep <= 1}
                    className="px-6 py-3"
                  >
                    ← Retour
                  </ButtonSecondary>

                  <div className="flex items-center space-x-6">
                    <div className="text-sm text-gray-500 dark:text-gray-400">
                      Étape {locationState.validationStep} sur {locationState.validationTotalSteps}
                    </div>

                    <ButtonPrimary
                      onClick={handleNextClick}
                      loading={isLoading}
                      disabled={isLoading}
                      className="px-8 py-3 text-base font-medium"
                    >
                      {locationState.validationStep === locationState.validationTotalSteps
                        ? "Finaliser"
                        : "Continuer →"}
                    </ButtonPrimary>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/*  */}
      </CommonLayout>
    </Fragment>
  );
};

export default Congrats;
